import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { history } from '@services/History'
import Consultations from '../../Services/Consultations'
import { useTranslation } from 'react-i18next'
import { getSearchLocation } from '../../utilities/mdHandler'
import MDBanner from '../core/components/MD.Banner'
import PasswordMeterField from '../formFields/passwordMeterField'
import SignInWrapper from './signinWrapper'

const PasswordReset = (props) => {
  const locationSearch = getSearchLocation(props)
  const [email] = useState(locationSearch.email)
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [token] = useState(props.match.params.token)
  const [error, setError] = useState(null)
  const enableButton = !!(password && password === passwordConfirmation)
  const { t } = useTranslation()
  const resetPassword = async () => {
    if (!password || !passwordConfirmation) {
      setError('no-password')
      return
    }
    if (password !== passwordConfirmation) {
      setError('no-passwords-match')
      return
    }
    try {
      await Consultations.auth.passwordReset({
        email,
        password,
        password_confirmation: passwordConfirmation,
        token,
      })
      history.push('/')
    } catch (e) {
      let status = e?.response?.status || true
      setError(status)
    }
  }
  return (
    <SignInWrapper>
      <div id="header" />
      <h2>{t('Restablecer la contraseña')}</h2>

      <PasswordMeterField handler={(e) => setPassword(e)} placeholder={t('Contraseña')} />
      <PasswordMeterField
        handler={(e) => setPasswordConfirmation(e)}
        placeholder={t('Repetir contraseña')}
        disableLevel={true}
        disablePanel={true}
      />

      {error && <MDBanner message={error} onClose={() => setError(null)} error />}

      <div className="buttons-container">
        <button disabled={!enableButton} onClick={() => resetPassword()}>
          {t('Enviar')}
        </button>
      </div>
    </SignInWrapper>
  )
}

export default withRouter(PasswordReset)
